import f from "../../../funcs";
import $ from "jquery";
import DragModal from "../DragModal";
import Marionette from "marionette";
import "../../../plugins/realSize";
import "../../../plugins/isVisible";
import "css!classes/modals/BoxModal/css/BoxModal";


let BoxModal = DragModal.extend("BoxModal", {
    cssName: "box-modal",
    View: Marionette.ItemView,
    minw: 160
});

BoxModal.prototype.init = function(params) {
    this.initialSize = {
        width: 150,
        height: 150
    };

    BoxModal.__super__.init.apply(this, arguments);
    params = params || {};

    this.$.css("z-index", 300000);
    this._nears = [];
    this.initResizeElems(params);
    this.initBlur();
    this.initView(params);

    this.paddings = 6;
    if ( f.isObject(params) && f.isNumber(params.paddings) ) {
        this.paddings = params.paddings;
    }
};

BoxModal.prototype.upMyZIndex = function() {
    BoxModal.__super__.upMyZIndex.apply(this, arguments);
    this.$.css("z-index", this.$.css("z-index") * 10);
};

// добавить элемент, клик по которому не вызовет blur
BoxModal.prototype.addNearElem = function($el) {
    this._nears.push($el);
};

BoxModal.prototype.show = function(options, callback) {
    if ( f.isFunction(options) ) {
        callback = options;
        options = {};
    }

    if ( !f.isFunction(callback) ) {
        callback = function() {};
    }

    options = f.deepMixin({
        trigger: true
    }, options);

    DragModal.activeModal(this);
    this.syncPageTitle();
    this.upMyZIndex();
    this.$[0].style.display = "block";
    setTimeout(function() {
        if ( options.trigger ) {
            this.trigger("show");
        }
        this.setSize(this.$.realSize());
        callback();
    }.bind(this), this.openTime);

    return this;
};

BoxModal.prototype.initResizeElems = function(params) {
    if ( params && params.resizeElems === false ) {
        return;
    }

    this.$resize = $("<div class='iresize box-modal-resize'></div>").appendTo(this.$box);
    this.$resize.html([1,2,3,4,5,6].map(function(i) {
        return "<span class='iresize box-modal-resize-square s" + i + "'></span>";
    }).join(""));
};

BoxModal.prototype.isInnerTarget = function(target) {
    let $target = $(target);
    let $modal = $target.parents(".modal-wrap");
    if ( $modal.get(0) == this.$.get(0) ) {
        return true;
    }

    let $near;
    let near;
    let parent;
    let parents = [].slice.call($target.parents()).concat(target);
    for (let i = 0, n = this._nears.length; i < n; i++) {
        $near = this._nears[i];
        near = $near.get(0);
        for (let j = 0, m = parents.length; j < m; j++) {
            parent = parents[j];
            if ( parent == near ) {
                return true;
            }
        }
    }

    return $target.parents(".column-filter-menu").length > 0;
};

BoxModal.prototype.toMinModals = function() {
    // отключаем поведение по умолчанию
    return;
};

BoxModal.prototype.syncPageTitle = function() {
    // отключаем поведение по умолчанию
    return;
};

BoxModal.prototype.full = function() {
    // отключаем поведение по умолчанию
    return;
};

BoxModal.prototype.initBlur = function() {
    this.listenTo($(window), "mousedown", function(e) {
        // LW-5563 чтобы gridList не исчезал при нажатии в пределах columnFilter
        const withinColumnFilter = e.target.closest("div.ColumnFilter");
        if ( withinColumnFilter ) {
            return;
        }
        if ( e.which == 3 ) {
            return;
        }

        if ( this.isInnerTarget(e.target) ) {
            return;
        }

        if ( !this.$.isVisible() ) {
            return;
        }

        this.blur(e);
    }.bind(this));
};

BoxModal.prototype.blur = function(e) {
    this.hide();
    this.trigger("blur", e);
};

BoxModal.prototype.initView = function(params) {
    if ( params.View === false ) {
        this.view = false;
        return;
    }

    let View = this.View || Marionette.View;
    this.$el = $("<div class='box-modal-view'><div/>").appendTo(this.$box);
    this.view = new View($.extend({
        modal: this,
        el: this.$el
    }, params.view));
};

BoxModal.prototype.onMousemoveResizeState = function() {
    this.setSize({
        width: this.width,
        height: this.height
    });
};

BoxModal.prototype.setSize = function(size) {
    let windowSize = f.getWindowSize();
    if ( !f.isObject(size) || !f.isNumber(size.width) || !f.isNumber(size.height) ) {
        size = f.deepClone(this.initialSize);
    }

    this.initialSize.width = Math.min(size.width, windowSize.width);
    this.initialSize.height = Math.min(size.height, windowSize.height);

    let paddings = this.paddings;
    if ( this.$el ) {
        this.$el.css({
            width: (size.width - paddings) + "px",
            height: (size.height - paddings) + "px"
        });
    }
    else if ( this.$box ) {
        this.$box.css({
            width: (size.width - paddings) + "px",
            height: (size.height - paddings) + "px"
        });
    }

    this.width = size.width;
    this.height = size.height;
};

BoxModal.prototype.moveTo = function(left, top) {
    this.$.css({
        top: top + "px",
        left: left + "px"
    });

    this.y = top;
    this.x = left;

    this.trigger("moveTo");
};

BoxModal.prototype.moveToEl = function($el, params) {
    params = f.deepMixin({ top: 0, left: 0 }, params);

    let rect = $el.get(0).getBoundingClientRect();
    let left = rect.left + params.left;
    let top = rect.top + rect.height + params.top;
    let width = Math.max(params.minWidth || 0, this.minw || 0, rect.width);

    let windowSize = f.getWindowSize();
    let windowWidth = windowSize.width;
    let windowHeight = windowSize.height;

    width = Math.min(width, windowWidth);

    if ( left + width > windowWidth ) {
        left = windowWidth - width - 10;
    }

    let css = {
        top: top + "px",
        left: left + "px"
    };

    let height = this.$.height();

    if ( height > windowHeight ) {
        height = windowHeight - 5;
        css.height = height + "px";
    }

    if ( top + height > windowHeight ) {
        top = top - height - rect.height - 2;
        css.top = top + "px";
    }

    this.$posEl = $el;


    this.$.css(css);


    if ( this.$el ) {
        this.$el.width(width);
    }

    if ( top < 100 ) {
        //console.log("catch me");
    }

    this.width = width;
    this.y = top;
    this.x = left;
    this.trigger("moveToEl");
};

BoxModal.prototype.updateAutoPosition = function() {
    if ( !this.$posEl ) {
        return;
    }

    let windowSize = f.getWindowSize();
    let windowWidth = windowSize.width;
    let windowHeight = windowSize.height;
    let $el = this.$posEl;
    let rect = $el.get(0).getBoundingClientRect();
    let modalSize = {
        width: this.$.width(),
        height: this.$.height()
    };
    let left = rect.left;
    let top = rect.top + rect.height;

    if ( modalSize.height > windowHeight ) {
        modalSize.height = windowHeight - 5;
        this.$.height(modalSize.height);
    }

    if ( modalSize.width > windowWidth ) {
        modalSize.width = windowWidth - 5;
        this.$.width(modalSize.width);
    }

    if ( modalSize.width + left > windowWidth ) {
        left = windowWidth - modalSize.width;
    }

    if ( modalSize.height + top > windowHeight ) {
        top = rect.top - modalSize.height;
    }

    if ( top < 0 ) {
        top = 0;
    }

    this.y = top;
    this.x = left;
    this.$.css({
        top: top + "px",
        left: left + "px"
    });

    modalSize.top = top;
    modalSize.left = left;

    return modalSize;
};

BoxModal.prototype.destroy = function() {
    BoxModal.__super__.destroy.apply(this, arguments);
    if ( this.view ) {
        this.view.destroy();
    }
};

export default BoxModal;
